export interface TimingMetadata {
  /** Local clock time captured when a user prompt is accepted for submission. */
  submittedAt?: string;
  /** Monotonic start marker retained only while the related response is active. */
  responseStartedAt?: number;
  /** Measured from response submission to the final stream completion event. */
  responseDurationMs?: number;
  /** Local clock time captured when the final stream completion event is received. */
  completedAt?: string;
}

/** Formats a browser-local clock value without seconds or a date. */
export function formatLocalTime(date = new Date()) {
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

/** Formats a monotonic elapsed duration without milliseconds or decimal values. */
export function formatResponseDuration(durationMs: number) {
  if (durationMs < 1_000) return '<1s';
  const totalSeconds = Math.floor(durationMs / 1_000);
  if (totalSeconds < 60) return `${totalSeconds}s`;
  return `${Math.floor(totalSeconds / 60)}m ${totalSeconds % 60}s`;
}

/** Keeps the first visible live value at 1s rather than briefly showing 0s. */
export function formatThinkingDuration(startedAt: number, currentTime: number) {
  return `${Math.max(1, Math.floor(Math.max(0, currentTime - startedAt) / 1_000) + 1)}s`;
}
